import React from 'react';

// One plan, kept simple: an introductory price with everything in the app,
// after a 60-day free trial for every new account (from 3 November 2026)
function PricingHomeOne({ className }) {
    return (
        <section className={`dd-pricing-area pt-90 pb-90 ${className || ''}`} id="pricing">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="dd-section-title text-center">
                            <h3 className="dd-title">Simple pricing</h3>
                            <p>
                                One plan with everything in the app. Every new account starts with
                                a 60-day free trial, and when it ends you can upgrade to paid.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-8 wow animated fadeInUp">
                        <div className="pricing-one__single center dd-pricing-single">
                            <div className="pricig-heading">
                                <h6>Drive.Day</h6>
                                <div className="price-range">
                                    <sup>&pound;</sup> <span>12</span>
                                    <p>/month</p>
                                </div>
                                <p>
                                    For your whole school, with 3 additional instructors &amp; admins
                                    included, after your 60-day free trial.
                                </p>
                            </div>
                            <div className="pricig-body">
                                <ul>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Diary with day, week and month views
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Pupil grouping and tags
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Fill diary gaps
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Broadcast messages
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Lesson feedback and reflections
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Lesson types and rates
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Free pupil app
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Syllabus and progress tracking
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Multi-user, add up to 8 instructors
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Money tracking and tax-year export
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Lesson reminders by push or text*
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> To-dos and notifications
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Customisation
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Shared school diary and pupils
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> Activity log and roles
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> GDPR tools and secure sign-in
                                        </li>
                                        <li>
                                            <i className="fa-jelly-fill fa-regular fa-check" /> And much, much more
                                        </li>
                                </ul>
                                <div className="pricing-btn mt-35">
                                    <a className="main-btn" href="#download">
                                        Download the apps
                                    </a>
                                </div>
                                <p className="dd-pricing-note">
                                    * Text messages may be limited and may need topping up, depending
                                    on use.
                                </p>
                                <p className="dd-pricing-note">
                                    The 60-day free trial and 3 included instructors &amp; admins apply
                                    to new accounts created from 3 November 2026.
                                </p>
                            </div>
                            <div className="pricing-rebon">
                                <span>Introductory offer</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PricingHomeOne;
